// Custom anatomical heart line icon (matches lucide-react API: className, strokeWidth)
export function AnatomicalHeart({ className = "", strokeWidth = 1.5, ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      {/* Great vessels: aorta + pulmonary trunk */}
      <path d="M11 6.2V4.4c0-1 .8-1.8 1.8-1.5 1 .3 1.2 1.4.6 2.3" />
      <path d="M13 4.9c.7-.8 2-.9 2.7-.1.7.8.5 2.1-.5 2.7" />
      <path d="M9.2 6.6C8.6 5.7 7.3 5.5 6.6 6.3c-.7.8-.4 2.1.6 2.6" />
      {/* Ventricular body with apex to lower-right */}
      <path d="M8.6 7.6C5.9 7.7 4 9.8 4 12.5c0 3.7 3.6 6.9 6.9 9 .5.3 1.1.2 1.5-.2 2.8-2.6 5.3-6 5.3-9.1 0-2.6-1.9-4.7-4.4-4.7-1.6 0-3.1.8-3.8 2.2" />
      {/* Coronary artery hint */}
      <path d="M10.2 10.2c1 2 1.5 5.2 1 8.3" />
    </svg>
  );
}
